import React from 'react';
import { CheckCircle, Dumbbell } from 'lucide-react';
import { aboutStory } from '../mock';

const AboutSection = () => {
  return (
    <section id="about" className="bg-[#0a0a0a] py-24">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          {/* Image */}
          <div className="relative">
            <div className="aspect-square rounded-lg overflow-hidden border-4 border-[#00ff41]">
              <img
                src="https://images.pexels.com/photos/36120641/pexels-photo-36120641.png"
                alt="Personal Training"
                className="w-full h-full object-cover"
              />
            </div>
            <div className="absolute -bottom-6 -right-6 bg-gradient-to-br from-[#00ff41] to-[#ff6b35] p-6 rounded-lg shadow-2xl">
              <div className="flex items-center gap-3">
                <Dumbbell size={32} className="text-black" />
                <div>
                  <div className="text-2xl font-black text-black">10K+</div>
                  <div className="text-sm text-black/80 font-bold">Transformations</div>
                </div>
              </div>
            </div>
          </div>

          {/* Content */}
          <div>
            <div className="inline-block mb-4 px-4 py-2 bg-[#00ff41]/10 border border-[#00ff41]/30 rounded-full">
              <span className="text-[#00ff41] font-semibold text-sm tracking-wider uppercase">
                My Journey
              </span>
            </div>
            <h2 className="text-4xl sm:text-5xl font-black text-white mb-6">
              {aboutStory.title}
            </h2>
            <p className="text-lg text-gray-300 leading-relaxed mb-8">
              {aboutStory.story}
            </p>

            <div className="space-y-3">
              {aboutStory.achievements.map((achievement, index) => (
                <div key={index} className="flex items-start gap-3">
                  <CheckCircle className="text-[#00ff41] flex-shrink-0 mt-1" size={20} />
                  <span className="text-gray-300">{achievement}</span>
                </div>
              ))}
            </div>

            <div className="mt-8 p-6 bg-gradient-to-r from-[#00ff41]/10 to-[#ff6b35]/10 border border-[#00ff41]/30 rounded-lg">
              <p className="text-white text-lg font-bold italic">
                "I don't just create fitness content — I help fitness brands convert audiences into paying customers."
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutSection;
